export function getSearchResultURL(
  locale: string,
  baseURL: string,
  brandSlug: string,
  brandCountry: 'UK' | 'US' | 'AU' | 'GB',
  programSlug?: string,
  isSpecialProgram?: boolean,
) {
  const searchResultURL: SearchResultUrls = {
    university: ``,
    program: ``,
    directEntry: ``,
  };

  const courses: string = brandCountry === 'US' ? 'programs' : 'courses';

  let specialProgramURL: string;
  if (isSpecialProgram) {
    specialProgramURL = `/universities/${brandSlug}/summary/${programSlug}`;
  } else {
    specialProgramURL = `/universities/${brandSlug}/${courses}/${programSlug}`;
  }

  searchResultURL.university = `/universities/${brandSlug}`;
  searchResultURL.program = specialProgramURL;
  searchResultURL.directEntry = specialProgramURL;
  searchResultURL.integratedMasters = `/universities/${brandSlug}/${courses}/integrated-masters-program`;

  return searchResultURL;
}
export class SearchResultUrls {
  university?: string;
  program?: string;
  directEntry?: string;
  integratedMasters?: string;
}
